module.exports = __webpack_public_path__ + "img/99-1.a8a78a9e.png";